module.exports = __webpack_public_path__ + "img/ico_circle_segment_black.98130a39.svg";